import React, { useState } from 'react';
import { observer } from 'mobx-react';

import { useStore } from 'stores';
import Loading from 'components/Loading';
import { FormCard } from 'components/Card';
import { ErrorMessage } from 'components/Message';
import { RequestersIcon } from 'components/Icon';

import { CreateForm, UserInputDictionary } from './CreateForm';

export const Page: React.FC = observer(() =>
{
  const { uiStore, requesterStore } = useStore();
  const [userInput, setUserInput] = useState<UserInputDictionary>({});

  return (
    <article className="page audience requester-create">
      <FormCard>
      {
        requesterStore.requester.isLoading
        ? <><h1>{uiStore.labels.common.loading}</h1><Loading /></>
        : <>
            <h1><RequestersIcon />{uiStore.labels.pages.audience.pages.requesterCreate.title}</h1>
            {requesterStore.requester.errorMessage ? <ErrorMessage>{requesterStore.requester.errorMessage}</ErrorMessage> : null}
            <CreateForm userInput={userInput} saveUserInput={(input: UserInputDictionary) => setUserInput(prev => input)} />
          </>
      }
      </FormCard>
    </article>
  );
});